import PredbeznaInformaciaListPage from './PredbeznaInformaciaListPage';

export default PredbeznaInformaciaListPage;
